(function () {
  'use strict';

  if (window.FQDestinationSearch && window.FQDestinationSearch.initialized) {
    return;
  }

  var STOREFRONT_TOKEN = '423afb7e832d6a8245c4b1f1e8ade220';
  var STOREFRONT_ENDPOINT = '/api/2024-10/graphql.json';

  function debounce(func, wait) {
    var timeout;
    return function () {
      var args = arguments;
      var context = this;
      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(context, args);
      }, wait);
    };
  }

  function extractCountryFromAddress(addressText) {
    var parts = addressText.split(',').map(function (part) {
      return part.trim();
    });
    if (parts.length >= 2) {
      return parts[parts.length - 1];
    }
    return null;
  }

  async function searchCollections(searchTerm) {
    try {
      var searchQuery = encodeURIComponent(searchTerm);
      var response = await fetch(
        '/search/suggest.json?q=' + searchQuery + '&resources[type]=collection&resources[limit]=10'
      );

      if (!response.ok) {
        return [];
      }

      var data = await response.json();
      if (
        data.resources &&
        data.resources.results &&
        data.resources.results.collections
      ) {
        return data.resources.results.collections;
      }

      return [];
    } catch (error) {
      return [];
    }
  }

  async function searchCollectionsAdvanced(searchTerm) {
    try {
      var searchQuery = encodeURIComponent(searchTerm);
      var response = await fetch(
        '/search?q=' + searchQuery + '&type=collection&limit=10&view=json'
      );

      if (!response.ok) {
        return [];
      }

      var data = await response.json();
      return data.results || [];
    } catch (error) {
      return [];
    }
  }

  function buildCollectionMetafieldsQuery(collectionIds) {
    if (!collectionIds || collectionIds.length === 0) {
      return '';
    }

    var queryFragments = collectionIds
      .map(function (id, index) {
        var alias = 'collection' + (index + 1);
        var gid = id.indexOf('gid://') === 0 ? id : 'gid://shopify/Collection/' + id;
        return (
          '\n    ' +
          alias +
          ': collection(id: "' +
          gid +
          '") {\n      id\n      title\n      handle\n      cityMetafield: metafield(namespace: "custom", key: "city") {\n        namespace\n        key\n        value\n        type\n      }\n      countryMetafield: metafield(namespace: "custom", key: "country") {\n        namespace\n        key\n        value\n        type\n      }\n    }'
        );
      })
      .join('');

    return 'query GetCollectionMetafields {' + queryFragments + '\n}';
  }

  async function fetchCollectionMetafields(collectionIds) {
    if (!collectionIds || collectionIds.length === 0) {
      return null;
    }

    try {
      var query = buildCollectionMetafieldsQuery(collectionIds);
      if (!query) {
        return null;
      }

      var response = await fetch(STOREFRONT_ENDPOINT, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({ query: query })
      });

      if (!response.ok) {
        return null;
      }

      var jsonResponse = await response.json();
      if (jsonResponse.errors || !jsonResponse.data) {
        return null;
      }

      return jsonResponse.data;
    } catch (error) {
      return null;
    }
  }

  function getCollectionIds(collections) {
    return collections
      .map(function (col) {
        if (col.id) {
          if (typeof col.id === 'string' && col.id.indexOf('gid://') === 0) {
            return col.id;
          }
          return 'gid://shopify/Collection/' + col.id;
        }
        if (col.collection_id) {
          return 'gid://shopify/Collection/' + col.collection_id;
        }
        return null;
      })
      .filter(Boolean);
  }

  function getCollectionHandle(match) {
    return match.handle || match.url.split('/').pop();
  }

  function showSearchStatus(searchBtn, searchingText) {
    var existing = document.getElementById('search-status');
    if (existing) {
      return;
    }

    var status = document.createElement('span');
    status.id = 'search-status';
    status.textContent = searchingText;
    if (searchBtn && searchBtn.parentNode) {
      searchBtn.parentNode.insertBefore(status, searchBtn.nextSibling);
    }
  }

  function clearSearchStatus() {
    var status = document.getElementById('search-status');
    if (status) {
      status.remove();
    }
  }

  async function handleCitySearchSmart(cityName, fullAddress) {
    try {
      var countryName = extractCountryFromAddress(fullAddress);
      var searchBtn = document.getElementById('search_button_add');
      var searchingText =
        (searchBtn && searchBtn.dataset.textSearching) || 'Searching...';

      showSearchStatus(searchBtn, searchingText);

      var cityCollections = await searchCollections(cityName);
      if (cityCollections.length === 0) {
        cityCollections = await searchCollectionsAdvanced(cityName);
      }

      if (cityCollections.length > 0) {
        var collectionIds = getCollectionIds(cityCollections);
        var matchedHandle = null;

        if (collectionIds.length > 0) {
          var metafieldsData = await fetchCollectionMetafields(collectionIds);
          if (metafieldsData) {
            for (var collectionKey in metafieldsData) {
              if (!Object.prototype.hasOwnProperty.call(metafieldsData, collectionKey)) {
                continue;
              }
              var collectionData = metafieldsData[collectionKey];
              if (!collectionData) {
                continue;
              }
              var city = collectionData.cityMetafield && collectionData.cityMetafield.value;
              if (
                city &&
                city.toLowerCase().trim() === cityName.toLowerCase().trim()
              ) {
                matchedHandle = collectionData.handle;
                break;
              }
            }
          }
        }

        var handle = matchedHandle || getCollectionHandle(cityCollections[0]);
        clearSearchStatus();
        return '/collections/' + handle;
      }

      if (countryName) {
        var countryCollections = await searchCollections(countryName);
        if (countryCollections.length === 0) {
          countryCollections = await searchCollectionsAdvanced(countryName);
        }

        if (countryCollections.length > 0) {
          var countryHandle = getCollectionHandle(countryCollections[0]);
          clearSearchStatus();
          return (
            '/collections/' +
            countryHandle +
            '?city=' +
            encodeURIComponent(cityName)
          );
        }
      }

      var alternativeSearches = [
        'gifts ' + cityName,
        cityName + ' gifts',
        'delivery ' + cityName,
        countryName ? 'gifts ' + countryName : null,
        countryName ? countryName + ' gifts' : null
      ].filter(Boolean);

      for (var i = 0; i < alternativeSearches.length; i++) {
        var results = await searchCollections(alternativeSearches[i]);
        if (results.length > 0) {
          var altHandle = getCollectionHandle(results[0]);
          clearSearchStatus();
          return (
            '/collections/' +
            altHandle +
            '?city=' +
            encodeURIComponent(cityName)
          );
        }
      }

      clearSearchStatus();
      var internationalUrl =
        '/collections/international?city=' + encodeURIComponent(cityName);
      if (countryName) {
        internationalUrl += '&country=' + encodeURIComponent(countryName);
      }
      return internationalUrl;
    } catch (error) {
      clearSearchStatus();
      return '/collections/international?city=' + encodeURIComponent(cityName);
    }
  }

  function initDesktopMenuSearch() {
    var addressInput = document.getElementById('address-input');
    var autocompleteResults = document.getElementById('autocomplete-results');
    if (!addressInput || !autocompleteResults) {
      return;
    }

    var searchBtn = document.getElementById('search_button_add');
    var searchLink = document.getElementById('search_button_add_linmk');
    var searchingText =
      (searchBtn && searchBtn.dataset.textSearching) || 'Searching...';
    var buttonText =
      (searchBtn && searchBtn.dataset.textDefault) || 'Search';

    var sessionToken = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0;
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );

    async function fetchAddressSuggestions(input) {
      if (input.length < 3) {
        autocompleteResults.style.display = 'none';
        return;
      }

      autocompleteResults.innerHTML =
        '<div class="loading-message">Loading...</div>';
      autocompleteResults.style.display = 'block';

      try {
        if (!window.FQ_GOOGLE || !window.FQ_GOOGLE.placesAutocomplete) {
          autocompleteResults.innerHTML =
            '<div class="no-results">No suggestions found</div>';
          return;
        }

        var preds = await window.FQ_GOOGLE.placesAutocomplete({
          input: input,
          sessionToken: sessionToken
        });

        if (preds && preds.length > 0) {
          autocompleteResults.innerHTML = '';
          preds.forEach(function (suggestion) {
            var description = suggestion.description || 'Unknown';
            var terms = suggestion.terms || [];
            var city = terms.length
              ? terms[0].value
              : (description.split(',')[0] || '').trim();
            var country = terms.length
              ? terms[terms.length - 1].value
              : (description.split(',').pop() || '').trim();
            var text = country ? city + ', ' + country : description;
            var div = document.createElement('div');
            div.textContent = text;
            div.classList.add('suggestion-item');
            div.setAttribute('data-full-address', text);
            autocompleteResults.appendChild(div);
          });
          autocompleteResults.style.display = 'block';
        } else {
          autocompleteResults.innerHTML =
            '<div class="no-results">No suggestions found</div>';
        }
      } catch (error) {
        autocompleteResults.innerHTML =
          '<div class="error-message">Error loading suggestions</div>';
      }
    }

    addressInput.addEventListener(
      'input',
      debounce(function (e) {
        fetchAddressSuggestions(e.target.value.trim());
      }, 300)
    );

    document.addEventListener('click', function (e) {
      if (!e.target.closest('#autocomplete-form')) {
        autocompleteResults.style.display = 'none';
      }
    });

    document.addEventListener('click', async function (e) {
      var suggestion = e.target.closest('#autocomplete-results .suggestion-item');
      if (suggestion) {
        var fullAddress = suggestion.textContent;
        var cityName = fullAddress.split(',')[0].trim();

        addressInput.value = fullAddress;
        setButtonLoading(searchBtn, true, searchingText, buttonText);
        autocompleteResults.style.display = 'none';

        try {
          var redirectUrl = await handleCitySearchSmart(cityName, fullAddress);
          if (searchLink) {
            searchLink.setAttribute('href', redirectUrl);
          }
          window.location.href = redirectUrl;
        } catch (error) {
          setButtonLoading(searchBtn, false, searchingText, buttonText);
        }
        return;
      }

      if (e.target.id === 'search_button_add' || e.target.closest('#search_button_add')) {
        e.preventDefault();
        var addressValue = addressInput.value.trim();
        if (!addressValue) {
          return;
        }

        var city = addressValue.split(',')[0].trim();
        setButtonLoading(searchBtn, true, searchingText, buttonText);

        try {
          var url = await handleCitySearchSmart(city, addressValue);
          window.location.href = url;
        } catch (error) {
          setButtonLoading(searchBtn, false, searchingText, buttonText);
        }
      }
    });
  }

  function setButtonLoading(btn, isLoading, searchingText, buttonText) {
    if (!btn) {
      return;
    }
    if (isLoading) {
      btn.classList.add('loading');
      if (searchingText) {
        btn.textContent = searchingText;
      }
    } else {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      btn.removeAttribute('data-loading');
      btn.textContent = buttonText || btn.dataset.defaultText || 'Search';
      btn.style.opacity = '1';
    }
  }

  function ensureMobileButtonDefaults(btn) {
    if (!btn) {
      return;
    }
    if (btn.dataset.defaultText && btn.dataset.defaultText.trim()) {
      return;
    }
    var current = btn.textContent && btn.textContent.trim() ? btn.textContent.trim() : '';
    if (!current || current.toLowerCase().indexOf('searching') !== -1) {
      btn.dataset.defaultText = 'Search';
    } else {
      btn.dataset.defaultText = current;
    }
  }

  function resetMobileButton(btn) {
    if (!btn) {
      return;
    }
    ensureMobileButtonDefaults(btn);
    setButtonLoading(btn, false, null, btn.dataset.defaultText);
  }

  function showMobileValidation(searchBox, message) {
    if (!searchBox) {
      return;
    }
    var el = searchBox.querySelector('.destinations-search-error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'destinations-search-error';
      searchBox.appendChild(el);
    }
    el.textContent = message;
    el.style.display = 'block';
  }

  function clearMobileValidation(searchBox) {
    if (!searchBox) {
      return;
    }
    var el = searchBox.querySelector('.destinations-search-error');
    if (el) {
      el.style.display = 'none';
    }
  }

  function hideMobileResults(container) {
    if (container) {
      container.style.display = 'none';
    }
  }

  function hideAllMobileResults() {
    document.querySelectorAll('.destinations-search-results').forEach(hideMobileResults);
  }

  function formatSuggestionText(suggestion) {
    var description =
      suggestion.description ||
      (suggestion.placePrediction &&
        suggestion.placePrediction.text &&
        suggestion.placePrediction.text.text) ||
      '';
    var terms = suggestion.terms || [];
    var city = terms.length
      ? terms[0].value || ''
      : (description.split(',')[0] || '').trim();
    var country = terms.length
      ? terms[terms.length - 1].value || ''
      : (description.split(',').pop() || '').trim();
    return country ? city + ', ' + country : description || city;
  }

  function showMobileResults(suggestions, container) {
    container.innerHTML = '';
    suggestions.forEach(function (suggestion) {
      var text = formatSuggestionText(suggestion);
      var item = document.createElement('div');
      item.className = 'search-result-item';
      item.textContent = text;
      item.setAttribute('data-location', text);
      container.appendChild(item);
    });
    container.style.display = 'block';
  }

  async function performMobileSearch(query, resultsContainer) {
    try {
      if (!window.FQ_GOOGLE || !window.FQ_GOOGLE.placesAutocomplete) {
        hideMobileResults(resultsContainer);
        return;
      }

      var suggestions = await window.FQ_GOOGLE.placesAutocomplete({
        input: query,
        sessionToken: 'mobile-dest-' + Date.now()
      });
      var top = Array.isArray(suggestions) ? suggestions.slice(0, 4) : [];
      if (top.length > 0) {
        showMobileResults(top, resultsContainer);
      } else {
        hideMobileResults(resultsContainer);
      }
    } catch (error) {
      hideMobileResults(resultsContainer);
    }
  }

  function initMobileDestinationsSearch() {
    if (document.querySelectorAll('.destinations-search-input').length === 0) {
      return;
    }

    if (window.FQDestinationSearch.mobileUIInitialized) {
      return;
    }
    window.FQDestinationSearch.mobileUIInitialized = true;

    var searchTimer;

    document.addEventListener('input', function (e) {
      if (!e.target.matches('.destinations-search-input')) {
        return;
      }

      var query = e.target.value.trim();
      var resultsContainer = e.target.parentNode.querySelector('.destinations-search-results');
      var searchBox = e.target.closest('.destinations-search-box');
      clearMobileValidation(searchBox);
      clearTimeout(searchTimer);

      if (query.length < 3) {
        hideMobileResults(resultsContainer);
        return;
      }

      searchTimer = setTimeout(function () {
        performMobileSearch(query, resultsContainer);
      }, 500);
    });

    document.addEventListener('click', async function (e) {
      if (e.target.matches('.search-result-item')) {
        e.preventDefault();

        var fullAddress = e.target.getAttribute('data-location');
        if (!fullAddress) {
          return;
        }

        var cityName = fullAddress.split(',')[0].trim();
        var searchBox = e.target.closest('.destinations-search-box');
        if (!searchBox) {
          return;
        }

        var input = searchBox.querySelector('.destinations-search-input');
        var searchBtn =
          searchBox.querySelector('.destinations-search-btn');
        var results = searchBox.querySelector('.destinations-search-results');
        var searchingText =
          (searchBtn && searchBtn.dataset.textSearching) || 'Searching...';

        if (input) {
          input.value = fullAddress;
        }
        clearMobileValidation(searchBox);

        if (searchBtn) {
          ensureMobileButtonDefaults(searchBtn);
          searchBtn.classList.add('loading');
          searchBtn.setAttribute('aria-busy', 'true');
          searchBtn.setAttribute('data-loading', '1');
          if (searchBtn.tagName === 'BUTTON') {
            searchBtn.disabled = true;
          }
          searchBtn.textContent = searchingText;
        }

        try {
          var redirectUrl = await handleCitySearchSmart(cityName, fullAddress);
          window.location.href = redirectUrl;
        } catch (error) {
          if (searchBtn) {
            resetMobileButton(searchBtn);
            if (searchBtn.tagName === 'BUTTON') {
              searchBtn.disabled = false;
            }
          }
        }

        hideMobileResults(results);
        return;
      }

      if (
        !e.target.closest('.destinations-search-box')
      ) {
        hideAllMobileResults();
      }
    });

    document.addEventListener('click', async function (e) {
      var btn = e.target.closest('.destinations-search-btn');
      if (!btn) {
        return;
      }

      e.preventDefault();

      var searchBox = btn.closest('.destinations-search-box');
      if (!searchBox) {
        return;
      }

      var input = searchBox.querySelector('.destinations-search-input');
      if (!input) {
        return;
      }

      var fullAddress = input.value.trim();
      if (!fullAddress) {
        var requiredText =
          searchBox.dataset.requiredText || 'This field is required.';
        showMobileValidation(searchBox, requiredText);
        return;
      }

      var cityName = fullAddress.split(',')[0].trim();
      var searchingLabel = btn.dataset.textSearching || 'Searching...';

      ensureMobileButtonDefaults(btn);
      btn.classList.add('loading');
      btn.setAttribute('aria-busy', 'true');
      btn.setAttribute('data-loading', '1');
      btn.textContent = searchingLabel;

      try {
        var url = await handleCitySearchSmart(cityName, fullAddress);
        window.location.href = url;
      } catch (error) {
        resetMobileButton(btn);
      }
    });

    window.addEventListener('pageshow', function () {
      document.querySelectorAll('.destinations-search-box').forEach(function (box) {
        resetMobileButton(box.querySelector('.destinations-search-btn'));
      });
    });
  }

  function initDestinationSearch() {
    initDesktopMenuSearch();
    initMobileDestinationsSearch();
  }

  window.FQDestinationSearch = {
    initialized: true,
    mobileUIInitialized: false,
    handleCitySearchSmart: handleCitySearchSmart,
    searchCollections: searchCollections
  };

  window.handleCitySearchSmart = handleCitySearchSmart;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDestinationSearch);
  } else {
    initDestinationSearch();
  }
})();
